import { render, staticRenderFns } from "./renewal-payments.vue?vue&type=template&id=146c9bee"
import script from "./renewal-payments.vue?vue&type=script&lang=js"
export * from "./renewal-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports